import { Navigate } from 'react-router-dom'
import { Shield } from 'lucide-react'
import { PageShell } from '@/components/common/PageShell'
import { SectionLoader } from '@/components/common/SectionLoader'
import { useMe } from '@/features/settings/hooks/useMe'
import { useAuthStore } from '@/stores/useAuthStore'
import { useRoles } from '../hooks/useRoles'
import { PermissionsMatrix } from './PermissionsMatrix'

export function PermissionsMatrixPage(): React.ReactElement {
  const storedRoleSlug = useAuthStore((s) => s.user?.roleSlug)
  const { data: me, isLoading: meLoading } = useMe()
  const { data: roles = [], isLoading, error, refetch } = useRoles()
  const meRoleSlug = typeof me?.roleId === 'string' ? undefined : me?.roleId.slug
  const roleSlug = meRoleSlug ?? storedRoleSlug

  if (meLoading) {
    return (
      <SectionLoader variant="table" cols={4} rows={6} label="Loading permissions" />
    )
  }

  if (roleSlug !== 'admin') {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <PageShell
      breadcrumbItems={[
        { label: 'Settings', to: '/settings' },
        { label: 'Permissions Matrix' },
      ]}
      icon={Shield}
      title="Permissions Matrix"
      description="Define granular access control for organizational roles."
      className="gap-0"
      hideHeader
    >
      <PermissionsMatrix roles={roles} isLoading={isLoading} error={error} onRetry={refetch} />
    </PageShell>
  )
}

PermissionsMatrixPage.displayName = 'PermissionsMatrixPage'
